export default {
  GET_ALL: `#graphql
  query getPrices($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getPrices(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        price,
        stringPrice
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getPricesHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getPricesHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        price,
        stringPrice,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewPrice($price: PriceInput!) {
    newPrice(input: $price)
    {
      price,
      stringPrice
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdatePrice($price: String!, $priceUpdate: PriceUpdateInput!) {
    updatePrice(price:$price, priceUpdate: $priceUpdate)
    {
      price
    }            
  }`,

  DELETE: `#graphql
  mutation DeletePrice($price: String!) {
    deletePrice(price:$price)
    {
      price
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/price.js